import { FormSection } from "Components/Shared/FormSection";
import { usePartyTypeList } from "Hooks/Options/usePartyTypeList";
import { Resources, useResource } from "Translations/Resources";
import type { PartyDto } from "Infrastructure/Api/Api";
import { Stack } from "@mui/material";
import { DataRow } from "Components/Shared/DataRow/DataRow";

const COMPONENT_RESOURCES =
  Resources.Pages.Content.UserDetailPageContent.Tabs.Party.Form.LegalEntity;

type Props = {
  party: PartyDto;
};

export const LegalEntityDataDisplay = ({ party }: Props) => {
  const { t } = useResource();
  const partyTypeList = usePartyTypeList({ onlyBusiness: false });

  const partyTypeName = partyTypeList.find(
    ({ code }) => code === party.type,
  )?.name;

  return (
    <FormSection legend={t(COMPONENT_RESOURCES.Legend.Company)}>
      <Stack gap={2}>
        <DataRow label={t(COMPONENT_RESOURCES.Type)} value={partyTypeName} />
        <DataRow
          label={t(COMPONENT_RESOURCES.CompanyName)}
          value={party.companyName}
        />
        <DataRow
          label={t(COMPONENT_RESOURCES.CompanyNumber)}
          value={party.companyNumber}
        />
        <DataRow
          label={t(COMPONENT_RESOURCES.TaxNumber)}
          value={party.taxNumber}
        />
      </Stack>
    </FormSection>
  );
};
